import Vue from "vue";
import base from "../../baseMarketing";

export default {
      ...base,

      apiUrl: '',
      API_SERVICE: '/marketing/automation',

      async list({ page = 0, filter }) {
        const url = this.userUrl({ path: `/flow` });

        return Vue.http.get(url, {
            params: {
              page,
              searchTerm: filter,
            },
        });
      },

      async create({ name }) {
        const url = this.userUrl({ path: `/flow` });

        return Vue.http.post(url, {
          name
        });
      },

      async edit({ automationId, name }) {
        const url = this.userUrl({ path: `/flow/${automationId}` });

        return Vue.http.put(url, {
          name
        });
      },

      async get({ automationId }) {
        const url = this.userUrl({ path: `/flow/${automationId}` });

        return Vue.http.get(url);
      },

      async steps({ automationId }) {
        const url = this.userUrl({ path: `/flow/${automationId}/steps` });

        return Vue.http.get(url);
      },

      async addStep({
        automationId,
        stepType,
        properties,
        previousStepId,
        locals,
        initialAge,
        finalAge,
        genderFilter,
        extraFields,
        useTerms        
      }) {
        const url = this.userUrl({ path: `/flow/${automationId}/step/` });

        return Vue.http.post(url, {
          stepType,
          properties,
          previousStepId,
          locals,
          initialAge,
          finalAge,
          genderFilter,
          extraFields,
          useTerms          
        });
      },

      async editStep({
        stepId,
        automationId,
        stepType,
        properties,
        previousStepId,
        locals,
        initialAge,
        finalAge,
        genderFilter,
        extraFields,
        useTerms        
      }) {
        const url = this.userUrl({ path: `/flow/${automationId}/step/${stepId}` });
        return Vue.http.put(url, {
          stepType,
          properties,
          previousStepId,
          locals,
          initialAge,
          finalAge,
          genderFilter,
          extraFields,
          useTerms          
        });
      },

      async duplicate({ automationId }) {
        const url = this.userUrl({ path: `/flow/${automationId}/copy` });

        return Vue.http.get(url);
      },

      async delete({ automationId }) {
        const url = this.userUrl({ path: `/flow/${automationId}/` });

        return Vue.http.delete(url);
      },

      async status({ automationId, status }) {
        const url = this.userUrl({ path: `/flow/${automationId}/status` });

        return Vue.http.patch(url, status);
      },

      async deleteStep({ automationId, stepId }) {
        const url = this.userUrl({ path: `/flow/${automationId}/step/${stepId}` });

        return Vue.http.delete(url);
      },

      async getLocalTree({ automationId, stepId }) {
        const url = stepId ? this.userUrl({ path: `/flow/${automationId}/step/${stepId}/locals ` }) : this.userUrl({ path: `/flow/${automationId}/step/locals ` });

        return Vue.http.get(url);
      },

      async listFlowsExternalType() {
        const url = this.userUrl({ path: `/flow/type/external` })

        return Vue.http.get(url);
      },
};
